import { i18n } from '@lingui/core';
import { Breadcrumbs } from '@warp-ds/react';
import IconChevronLeft16 from '@warp-ds/icons/react/chevron-left-16';
import React from 'react';
import { BreadCrumbListItem } from '../../../server';
import { useAppConfig } from '../../AppConfig';
import { useSeoData } from '../../data/SeoData';
import { useFeatureToggles } from '../useFeatureToggles';

function desktop(breadCrumbsItems: BreadCrumbListItem[]) {
    return (
        <Breadcrumbs className="py-8 mb-16">
            {breadCrumbsItems.map((breadCrumb, index) =>
                breadCrumbsItems.length - 1 === index ||
                breadCrumbsItems.length === 1 ? (
                    <span
                        key={`breadCrumb${breadCrumb.position}`}
                        aria-current="page"
                    >
                        {breadCrumb.label}
                    </span>
                ) : (
                    <a
                        key={`breadCrumb${breadCrumb.position}`}
                        href={breadCrumb.link}
                    >
                        {breadCrumb.label}
                    </a>
                ),
            )}
        </Breadcrumbs>
    );
}

function mobile(breadCrumbsItems: BreadCrumbListItem[]) {
    return (
        <nav
            className="py-8 flex mb-16 space-x-0 content-center"
            aria-labelledby="breadCrumbLabel"
        >
            <h2 id="breadCrumbLabel" className="sr-only">
                {i18n.t({
                    id: 'breadcrumbs.you-are-here',
                    message: 'You are here',
                })}
            </h2>
            {breadCrumbsItems.map((breadCrumb, index) => {
                if (breadCrumbsItems.length - 2 === index)
                    return (
                        <span
                            key={`breadCrumb${breadCrumb.position}`}
                            className="flex items-center"
                        >
                            <IconChevronLeft16 className="mr-4" />
                            <a
                                key={`breadCrumb${breadCrumb.position}`}
                                href={breadCrumb.link}
                            >
                                {breadCrumb.label}
                            </a>
                        </span>
                    );

                if (breadCrumbsItems.length - 1 === index)
                    return (
                        <span
                            key={`breadCrumb${breadCrumb.position}`}
                            aria-current="page"
                            className="hidden"
                        >
                            {breadCrumb.label}
                        </span>
                    );

                return (
                    <a
                        key={`breadCrumb${breadCrumb.position}`}
                        href={breadCrumb.link}
                        className="hidden"
                    >
                        {breadCrumb.label}
                    </a>
                );
            })}
        </nav>
    );
}

export function BreadCrumbs() {
    const { seoData } = useSeoData();
    const breadCrumbsItems = seoData?.data.breadcrumbs_ui.items ?? [];

    const featureToggles = useFeatureToggles();
    const isEnabled = Boolean(featureToggles.seoApi);

    const { isProbablyMobile } = useAppConfig();

    if (!isEnabled || breadCrumbsItems.length === 0) {
        return null;
    }

    return isProbablyMobile
        ? mobile(breadCrumbsItems)
        : desktop(breadCrumbsItems);
}
